/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import api from "../../api";
import image from "../../assets/images/OT_only_name.png"
import { Loader } from "../../components/loader";
import { useNavigate } from "react-router-dom";
import authManager from "../../utils/authManager";
import { 
  StyledHeaderContainer,
  LoaderContainer,
  StyledTitle,
  StyledSubTitle,
  StyledContentText,
  NavbarActions,
  StyledUserButton,
  StyledAccountIcon,
  StyledMenu,
  pageContainerStyle,
  brandLogoStyle,
  userButtonContainerStyle,
  contentContainerStyle,
  welcomeTextStyle,
 } from "./styles";
 import { LoadingSpinner } from "../../components/loading_spinner";
 import { useNotificationContext } from "../../contexts/notificationContext";
 import { StyledMenuItem } from "../../components/styled_menu_item";

export const NoPermissionPage = () => {
  const [data, setData] = React.useState({})
  const [status, setStatus] = React.useState(true)
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [loading, setLoading] = React.useState(false)
  const navigate = useNavigate();
  const showNotication = useNotificationContext();
  const open = Boolean(anchorEl);

  React.useEffect(() => {
    api.get('/v1/admin/me')
    .then((response) => {
      setData(response.data)
      setStatus(false)
    })
    .catch((error) => {
      setStatus(false)
      console.log(error)
    })
  }, [])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogOut = async () => {
    setLoading(true)
    authManager.logout(true);
    showNotication("Logged out successfully", "success");
    setAnchorEl(null);
    setLoading(false)
  };

  return (
    <React.Fragment>
      <div style={pageContainerStyle}>
        <StyledHeaderContainer>
          <img src={image} alt="Brand Logo" style={brandLogoStyle}/>
          <NavbarActions className="header-info" elevation={0}>
            <div style={userButtonContainerStyle}>
              <StyledUserButton
                startIcon={<StyledAccountIcon />}
                onClick={handleClick}
              >
                {data?.first_name}
              </StyledUserButton>
              <StyledMenu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <StyledMenuItem onClick={handleLogOut}>{ loading ? <LoadingSpinner isLoading={true} /> : 'Log out'}</StyledMenuItem>
              </StyledMenu>
            </div>
          </NavbarActions>
        </StyledHeaderContainer>

        {
          status ? (
            <LoaderContainer>
              <Loader />
            </LoaderContainer>
          ) : (
            <div style={contentContainerStyle}>
              <StyledTitle>{`Welcome to OwnersTable, ${data?.first_name}`}</StyledTitle>
              <StyledSubTitle>You're almost ready to go!</StyledSubTitle>
              <StyledContentText style={welcomeTextStyle}>
                But it looks like your account hasn't been assigned access to any restaurant or group yet.
              </StyledContentText>
              <StyledContentText style={welcomeTextStyle}>Please contact your administrator to complete your setup.</StyledContentText>
            </div>
          )
        }
      </div>
    </React.Fragment>
  )
}
